import DCMTagMarker from "./DCMTagMarker";
export { DCMTagMarker as default };
